<template>
  <div>
    <header id="header_top">
      <section class="head_back" @click="goIndex">
        <img src="~assets/images/back-btn.png" alt />
        <span>{{ headTitle }}</span>
      </section>
      <slot name="ask-title"></slot>
    </header>
    <div class="wrapper">
      <answer-party :hotQuestion="hotData" :symbolMap="symbolMap" />
      <div class="load_more" @click="loadMore" v-show="showMore">点击加载更多</div>
    </div>
    <load-ing v-show="showLoad"></load-ing>
  </div>
</template>

<script>
import answerParty from "components/answerParty";
import { toast } from "assets/commonjs/toast";
import { getStore, setStore } from "assets/commonjs/storage";
import loadIng from "components/loading/loading";
import { getQueryString } from "assets/commonjs/tool";
export default {
  data() {
    return {
      title: "问答大厅",
      pageSize: 6,
      pageNum: 0,
      hotData: [],
      companyId: 1,
      headTitle: "问答大厅",
      // isApp: true,
      showMore: false,
      showLoad: true, //是否显示加载中
      symbolMap: {}
    };
  },
  components: {
    answerParty,
    loadIng
  },
  mounted() {
    window.getInfoCallback = this.appgetUserInfo;
  },
  methods: {
    mechined: function () {
      var u = navigator.userAgent;
      var isAndroid = u.indexOf("Android") > -1 || u.indexOf("Adr") > -1; // android终端
      var isiOS = !!u.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/); // ios终端
      if (isAndroid) return 0;
      if (isiOS) return 1;
      else return -1;
    },
    getTopicData(type) {
      let userToken;
      // alert(getStore("userInfoAll"))
      if (
        getStore("userInfoAll") == undefined ||
        getStore("userInfoAll") == null ||
        getStore("userInfoAll") == ""
      ) {
        userToken = "";
      } else {
        let userInfoAll = JSON.parse(getStore("userInfoAll"));
        userToken = userInfoAll.userToken;
      }
      // alert(userToken)
      this.getData(type, userToken);
    },
    getData(type, userToken) {
      // alert("获取数据" + userToken)
      let data = {
        companyId: this.companyId,
        pageSize: this.pageSize,
        pageNum: this.pageNum,
        userToken: userToken
      };
      this.$api.strageList.getTopicData(data).then(res => {
        if (res.data && res.data.code == 0) {
          this.showLoad = false;
          if (res.data.result.length > 10) {
            this.showMore = true;
          }
          if (type == "more") {
            if (res.data.result.length == 0) {
              toast("没有更多数据了");
            }

            this.hotData = this.hotData.concat(res.data.result);
          } else {
            this.hotData = res.data.result;
          }
        } else {
          toast(res.data.message);
        }
      });
    },
    loadMore() {
      this.pageNum += this.pageSize;
      this.getTopicData("more");
    },
    goIndex() {
      this.$router.push("/");
    },
    getAppUserInfo: function () {
      let useInfo,
        type = this.mechined();
      //如果是安卓手机浏览器且是配置的是APP内应用
      if (type == 0 && typeof window.uiObject !== "undefined") {
        useInfo = window.uiObject.getInfo(); //android终端

        let userInfo = JSON.parse(useInfo);

        if (
          userInfo.account != "" &&
          userInfo.account != undefined &&
          userInfo.account != null
        ) {
          this.autoLogin(userInfo.account);
        } else {
          setStore("userInfoAll", "");
          this.getTopicData();
        }
      } else {
        //兼容旧版本
        if (typeof window.getInfo !== "undefined") {
          useInfo = window.getInfo();

          let userInfo = JSON.parse(useInfo);
          if (
            userInfo.account != "" &&
            userInfo.account != undefined &&
            userInfo.account != null
          ) {
            this.autoLogin(userInfo.account);
          } else {
            setStore("userInfoAll", "");
            this.getTopicData();
          }
        } else {
          window.webkit.messageHandlers.getInfo.postMessage("");
        }
      }
    },
    autoLogin(appString) {
      let data = {
        customer: appString
      };
      this.$api.strageList.autoLogin(data).then(res => {
        if (res.data == null || res.data == "") {
          //mis后台为调用成功
          toast("app账号和密码不符合要求");
          return;
        }
        let msg = res.data.ch_msg[0];
        if (msg == null) {
          return;
        }
        this.userIpInfo(msg);

      });
    },
    userIpInfo(msg) {
      let userSource, userDevice, userIpInfo;
      if (
        getStore("noneheader") != "" &&
        getStore("noneheader") != undefined &&
        getStore("noneheader") != null
      ) {
        userSource = "App";
      } else {
        userSource = "M站";
      }
      if (this.mechined() == 0) {
        userDevice = "Android";
      } else if (this.mechined() == 1) {
        userDevice = "IOS";
      } else {
        userDevice = "PC";
      }
      userIpInfo = {
        userSource: userSource,
        userDevice: userDevice,
        userDeviceDetail: navigator.userAgent
      };
      this.getUserInfo(msg, userIpInfo);
    },
    getUserInfo(userInfo, userIpInfo) {
      let account = String(userInfo.account);
      if (account.startsWith("11")) {
        this.userType = 2;
      } else {
        this.userType = 1;
      }
      let userStatus;
      if (userInfo.activeStatus > 0 || userInfo.activeStatus != "") {
        userStatus = 1;
      } else if (userInfo.activeStatus == "") {
        userStatus = 0;
      }
      let data = {
        account: userInfo.account,
        userStatus: userStatus,
        phone: userInfo.phone,
        userLevel: userInfo.userLevel,
        userName: userInfo.userName,
        email: userInfo.email,
        companyId: this.companyId,
        userType: this.userType,
        userSource: userIpInfo.userSource,
        userDevice: userIpInfo.userDevice,
        userDeviceDetail: userIpInfo.userDeviceDetail
      };
      this.$api.strageList.loginInfo(data).then(res => {
        if (res.data && res.data.code == 0) {
          let userToken = res.data.result.userToken;
          setStore("userInfoAll", JSON.stringify(res.data.result));
          this.getData("", userToken);
        } else {
          toast(res.data.message);
        }
      });
    },
    appgetUserInfo(info) {
      // 新版ios 走这里
      if (
        info.account != "" &&
        info.account != undefined &&
        info.account != null
      ) {
        //已经登录
        this.autoLogin(info.account);
        setStore("noneheader", "yes");
      } else {
        setStore("userInfoAll", "");
        this.getData("", "");
      }
    },

    getAllSymbalData() {
      this.$api.strageList.getProductData().then(res => {
        if (res.data.code == 0 && res.data.msg == "成功") {
          for (var i in res.data.data) {
            this.symbolMap[res.data.data[i].symbol] = res.data.data[i];
          }
        }

        if (getQueryString("noneheader")) {
          setTimeout(() => {
            this.getAppUserInfo();
          }, 1000);
        } else {
          this.getTopicData();
        }
      });
    }
  },
  created() {
    this.getAllSymbalData();
    this.pageNum = 0;
  }
};
</script>

<style lang="scss" scoped>
@import "~assets/styles/mixin";

.wrapper {
  padding: 0.3rem;
  background: #f0f1f5;

  .answer_list::v-deep ul {
      li {
        box-shadow: none;
        background: #fff;
      }
  }

  .load_more {
    @include sc(0.3rem, #333);
    text-align: center;
  }
}

#header_top {
  @include wh(100%, 0.9rem);
  position: relative;
  background: #fff;
  border-bottom: 0.025rem solid #ddd;
}

.head_back {
  @include wh(auto, 0.9rem);
  padding-top: 0.1rem;
  line-height: 0.9rem;
  margin-left: 0.3rem;
  font-size: 0;
  text-align: left;
  float: left;

  img {
    @include wh(0.44rem, 0.44rem);
    position: relative;
    top: 0.1rem;
  }

  span {
    @include center;
    font-size: 0.32rem;
    font-weight: bold;
  }
}
</style>